import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { z } from 'zod';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';
import { requireSystemAdmin } from '~/utils/guards';

/**
 * Data Lake upload wizard route (`/explorer/datalake/upload`). Super-admin
 * only, matching the browser route it is reached from — this writes into raw
 * subsidiary storage. Lazy-loaded to keep it off the initial bundle.
 *
 * The filename's trailing `_` (`datalake_.upload`) opts this route OUT of
 * nesting under `datalake.tsx`. Without it the router treats `datalake.tsx` as
 * this route's layout parent, and since that file renders the browser page with
 * no `<Outlet/>`, navigating here would silently keep showing the browser.
 */
const DatalakeUploadPage = lazy(() => import('~/features/explorer/pages/datalake-upload-page'));

// Mirrors the browser route's schema so the shared `?sc=` subsidiary scope
// survives navigating in and back out again.
const searchSchema = z.object({
  sc: z.string().optional(),
});

export const Route = createFileRoute('/_authenticated/_tenant/explorer/datalake_/upload')({
  validateSearch: searchSchema,
  beforeLoad: requireSystemAdmin(),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <Suspense fallback={<PageSkeleton />}>
      <DatalakeUploadPage />
    </Suspense>
  );
}
